const TOKEN_KEY = 'token';

/** Единственное место в приложении, которое знает, где лежит токен. */
export const getToken = (): string | null => localStorage.getItem(TOKEN_KEY);

export const setToken = (token: string): void => localStorage.setItem(TOKEN_KEY, token);

export const clearToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem('organizationId');
  localStorage.removeItem('isFeedbackSurveyCompleted');
  sessionStorage.removeItem('showFeedbackSurvey');
};
